import * as React from "react";
import {
    List,
    Show,
    Edit,
    Create,

    Datagrid,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    EmailField,
    DateField,
    TextInput,
    DateInput,
    BooleanField,
    ArrayField,
    SelectField,
    SelectInput,

    TabbedShowLayout,
    Tab,
    Toolbar,
    SaveButton,
    useRecordContext,
    Button,
    NumberField,
    NumberInput,
    FormDataConsumer,
    WrapperField,
    FunctionField,
    TopToolbar,
    EditButton,
    Confirm,
    useDataProvider,
    useRedirect,
    useNotify,
    TabbedForm,
    ArrayInput,
    SimpleFormIterator,
    Link,
    CreateButton,
    ReferenceInput,
    AutocompleteInput,
    maxValue,
    useGetOne,
    usePermissions,
    AddItemButton,
    RichTextField,
    WithListContext,
    SingleFieldList,
    ChipField,
    SimpleList,
    BooleanInput,
} from 'react-admin';
import { useController, useForm, useWatch } from "react-hook-form";
import Grid from '@mui/material/Grid';
import Alert from "@mui/material/Alert";
import { ConditionalScoringField, FormEntryCommunityField } from "../Resources/FormEntries";
import { formStatuses, generateRandomString, getStatuses, toSelectChoices } from "../helpers/strings";
import { authenticatedApi } from "../dataProvider";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import { format, formatISO, max, parseISO } from "date-fns";
import { RichTextInput } from "ra-input-rich-text";
import { SimpleRichTextInputToolbar } from "../Components/SimpleRichTextInputToolbar";
import { ConfirmRemoveItemButton } from "./ConfirmRemoveItemButton";

export const additionalSchemaChoices = [
    { id: 'text', name: 'Text Box' },
    { id: 'boolean', name: 'Yes/No' },
    { id: 'multichoice', name: 'Multiple Choice (Checkboxes)' },
    { id: 'choice', name: 'Single Choice (Dropdown)' },
    { id: 'date', name: 'Date' },
    { id: 'file', name: 'File' },
];

export const additionalSchemaTypes = additionalSchemaChoices.reduce((result, item) => {
    result[item.id] = item.name;
    return result;
});

export const AdditionalSchemaInput = (props) => {
    const record = useRecordContext();

    let filteredAdditionalSchemaChoices = [
        ...additionalSchemaChoices
    ];
    if(props.excludedQuestionTypes && Array.isArray(props.excludedQuestionTypes)) {
        for(const excludedType of props.excludedQuestionTypes) {
            filteredAdditionalSchemaChoices = filteredAdditionalSchemaChoices.filter(obj => obj.id !== excludedType);
        }
    }

    // if the record has a form that means we're editing the coordinating program form, which should be limited to either question per standard, or 5, whichever is bigger
    let maxQuestions = 999;
    if(props.limitQuestions && record.hasOwnProperty('form')) {
        maxQuestions = 5; // set to 5 by defalut

        // try to set to the # of standards
        try {
            maxQuestions = Math.max(record.form.standards.length, 5);
        } catch(e) {
            //
        }
    }

    // const generateId;

    return (
        <FormDataConsumer>
        {({ formData, scopedFormData, getSource, ...rest }) => (
            <ArrayInput source="additional_schema" label={""}>
                <SimpleFormIterator
                    fullWidth
                    inline
                    getItemLabel={index => <span style={{marginTop: '1rem'}}>#{index + 1}</span>}
                    disableAdd={formData.additional_schema && formData.additional_schema.length > (maxQuestions - 1)}
                    addButton={formData.additional_schema && formData.additional_schema.length === 0 ? <Button label="Add Question"><AddIcon size="small"/></Button> : <AddItemButton label="Add Question" />}
                    removeButton={<ConfirmRemoveItemButton/>}
                >
                {/* <TextInput source="question" multiline fullWidth isRequired /> */}
                {/* <RichTextInput source="description" fullWidth toolbar={<SimpleRichTextInputToolbar />} /> */}

                <TextInput source="id" defaultValue={generateRandomString()} style={{display: 'none'}} />

                <RichTextInput source="question" fullWidth toolbar={<SimpleRichTextInputToolbar />} />

                <BooleanInput source="required" label="Is the question required?" fullWidth={true} defaultValue={true} />

                <div style={{width: '100%'}}></div>

                <SelectInput isRequired source="type" placeholder="Choose type" choices={filteredAdditionalSchemaChoices} />

                <FormDataConsumer>
                {({ formData: nestedFormData, scopedFormData: nestedScopedFormData, getSource: nestedGetSource, ...nestedRest }) => {
                    if(nestedScopedFormData && ['text', 'boolean', 'file'].indexOf(nestedScopedFormData.type) !== -1) {
                        {/* return (<em>No additional configuration</em>) */}
                    }
                    if(nestedScopedFormData && ['multichoice', 'choice'].indexOf(nestedScopedFormData.type) !== -1) {
                        return (<>
                            {nestedScopedFormData.type === 'multichoice' && (<>
                            <NumberInput source={nestedGetSource('max')} label="Max choices" helperText={'Leave blank if there is no limit'} />
                        </>)}
                        <BooleanInput
                            source={nestedGetSource('display_other')}
                            label='Include an "other" option?'
                            fullWidth
                            defaultValue={false}
                            helperText='If a user selects "other", they will be required to explain in a text box.'
                        />
                        <div style={{width: '100%'}}></div>
                        <ArrayInput source={nestedGetSource('options')} label={"Options"} defaultValue={['']} sx={{marginTop: '1rem', '.RaSimpleFormIterator-list': {marginLeft: '2rem'}}}>
                            <SimpleFormIterator
                                inline
                                // fullWidth
                                // getItemLabel={index => `#${index + 1}`}
                                // disableAdd={formData.additional_schema && formData.additional_schema.length > 4}
                                disableRemove={nestedFormData.options && nestedFormData.options.length == 1}
                                removeButton={<ConfirmRemoveItemButton/>}
                                // addButton={nestedFormData.options && nestedFormData.options.length === 0 ? <Button label="Add Option"><AddIcon size="small"/></Button> : <AddItemButton label="Add Option" />}
                                addButton={<Button label="Add Option"><AddIcon size="small"/></Button>}
                                disableClear
                            >
                                <TextInput label="Option" isRequired />
                            </SimpleFormIterator>
                        </ArrayInput>
                        </>);
                    }

                    return null;
                    }}
                </FormDataConsumer>

                {/* leave this last because otherwise it autofocuses weird */}
                {/* <TextInput source="id" defaultValue={generateRandomString()}/> */}

                </SimpleFormIterator>
            </ArrayInput>
        )}
        </FormDataConsumer>
    );
}


export const AdditionalSchemaField = () => {
    return (<>
        {/* <FormDataConsumer> */}
        {/* {({ formData, scopedFormData, getSource, ...rest }) => ( */}
            <ArrayField source="additional_schema" label={""}>
                <Datagrid bulkActionButtons={false}>
                    <RichTextField sortable={false} source="question" />

                    <WrapperField sortable={false} source="type" label="Type">
                        <SelectField source="type" placeholder="Choose type" choices={additionalSchemaChoices} />

                        <FunctionField source="options" label="Options" render={record => record.options ? (
                            <><br/>{record.options.join(", ")}</>
                        ):null} />
                            {/* <><b>{record.title}</b><br/><p dangerouslySetInnerHTML={{__html: record.message}}></p></> */}

                        {/*
                        <ArrayField source="options">
                            <SimpleList primaryText={record => record}/>
                        </ArrayField>
                        */}
                    </WrapperField>

                    <BooleanField sortable={false} source="required" looseValue />

                </Datagrid>


                {/*
                <FormDataConsumer>
                {({ formData: nestedFormData, scopedFormData: nestedScopedFormData, getSource: nestedGetSource, ...nestedRest }) => {
                    if(nestedScopedFormData && ['text', 'boolean'].indexOf(nestedScopedFormData.type) !== -1) {
                    }
                    if(nestedScopedFormData && ['multichoice', 'choice'].indexOf(nestedScopedFormData.type) !== -1) {
                        return (
                        <ArrayField source={nestedGetSource('options')} label={"Options"} defaultValue={[{'option':''}]} sx={{marginLeft: '2rem'}}>
                            <SimpleFormIterator
                                inline
                                // fullWidth
                                // getItemLabel={index => `#${index + 1}`}
                                // disableAdd={formData.additional_schema && formData.additional_schema.length > 4}
                                disableRemove={nestedFormData.options && nestedFormData.options.length == 1}
                                removeButton={<ConfirmRemoveItemButton/>}
                                // addButton={nestedFormData.options && nestedFormData.options.length === 0 ? <Button label="Add Option"><AddIcon size="small"/></Button> : <AddItemButton label="Add Option" />}
                                addButton={<Button label="Add Option"><AddIcon size="small"/></Button>}
                                disableClear
                            >
                                <TextField label="Option" isRequired />
                            </SimpleFormIterator>
                        </ArrayField>
                        );
                        //
                    }

                    return null;
                    }}
                </FormDataConsumer>
                */}

                {/*
                // select for form type
                // yes/no, text field, checkboxes, dropdown (one choice per line)
                // optional notes field for yes/no, dropdown
                // nested repeater arrayInput for dropdown
                */}

                {/* <Grid container spacing={2} alignItems="center"> */}
                    {/* <Grid item> */}
                        {/* <TextInput source="label" label="Label" sx={{display: 'flex'}} /> */}
                    {/* </Grid> */}
                    {/* <Grid item> */}
                        {/* <BooleanInput source="show_label" label="Show label on Portal?" /> */}
                    {/* </Grid> */}
                {/* </Grid> */}

                {/* </SimpleFormIterator> */}
            </ArrayField>
        {/* )} */}
        {/* </FormDataConsumer> */}
        </>);
}
